import { gql } from "@apollo/client";
import {
  DataCoreBaseProductDeepNestingFragment,
  DataCoreBaseProductInventoryPricingDeepNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const QUERY_FIND_BASE_PRODUCT_BY_SKU = gql`
  ${DataCoreBaseProductDeepNestingFragment}
  ${DataCoreBaseProductInventoryPricingDeepNestingFragment}
  query getBaseProductByBarcode($barcode: String!) {
    getBaseProductByBarcode(barcode: $barcode) {
      ...DataCoreBaseProductDeepNesting
    }
  }
`;
